export default {
  step: 1,
  addresses: [],
  originalAddresses: []
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/usps/state.js